import { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import api from "../../services/api";

export default function ClaimForm({ claim, onSave, onCancel }) {
  var policiesState = useState([]);
  var policies = policiesState[0];
  var setPolicies = policiesState[1];
  var formState = useState({
    policy_id: claim ? claim.policy_id : "",
    description: claim ? claim.description : "",
    claim_type: claim ? claim.claim_type : "colisao",
    damage_value: claim ? claim.damage_value : "",
    approved_value: claim ? (claim.approved_value || "") : "",
    status: claim ? claim.status : "aberto",
    notes: claim ? (claim.notes || "") : "",
  });
  var form = formState[0];
  var setForm = formState[1];
  var savingState = useState(false);
  var saving = savingState[0];
  var setSaving = savingState[1];

  useEffect(function() {
    api.get("/policies?limit=100&status=ativa").then(function(r) { setPolicies(r.data.policies || []); });
  }, []);

  function handleChange(field, value) {
    setForm(function(prev) { var n = {}; for (var k in prev) n[k] = prev[k]; n[field] = value; return n; });
  }

  function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    if (claim) {
      api.put("/claims/" + claim.id, { description: form.description, claim_type: form.claim_type, status: form.status, damage_value: parseFloat(form.damage_value) || 0, approved_value: form.approved_value ? parseFloat(form.approved_value) : null, notes: form.notes || null })
        .then(function() { onSave(); }).finally(function() { setSaving(false); });
    } else {
      api.post("/claims", { policy_id: form.policy_id, description: form.description, claim_type: form.claim_type, damage_value: parseFloat(form.damage_value) || 0, notes: form.notes || null })
        .then(function() { onSave(); }).finally(function() { setSaving(false); });
    }
  }

  var isEdit = !!claim;

  return (
    <div data-testid="claim-form">
      <button onClick={onCancel} className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4"><ArrowLeft className="w-4 h-4" />Voltar</button>
      <div className="bg-white rounded-xl p-6 shadow-sm border max-w-xl">
        <h3 className="text-lg font-bold text-[#0A2F3D] mb-4">{isEdit ? "Editar Sinistro" : "Novo Sinistro"}</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          {!isEdit && (
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Apolice</label>
              <select required value={form.policy_id} onChange={function(e) { handleChange("policy_id", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="claim-policy">
                <option value="">Selecione a apolice...</option>
                {policies.map(function(p) { return <option key={p.id} value={p.id}>{p.policy_number} - {p.client_name} ({p.insurer_name})</option>; })}
              </select>
            </div>
          )}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Tipo de Sinistro</label>
              <select required value={form.claim_type} onChange={function(e) { handleChange("claim_type", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="claim-type">
                <option value="colisao">Colisao</option>
                <option value="roubo">Roubo</option>
                <option value="incendio">Incendio</option>
                <option value="alagamento">Alagamento</option>
                <option value="terceiros">Terceiros</option>
                <option value="outros">Outros</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Valor do Dano (R$)</label>
              <input type="number" step="0.01" min="0" value={form.damage_value} onChange={function(e) { handleChange("damage_value", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="claim-damage" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Descricao</label>
            <textarea required value={form.description} onChange={function(e) { handleChange("description", e.target.value); }} rows={3} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="claim-description" />
          </div>
          {isEdit && (
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                <select value={form.status} onChange={function(e) { handleChange("status", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="claim-status">
                  <option value="aberto">Aberto</option>
                  <option value="em_analise">Em Analise</option>
                  <option value="aprovado">Aprovado</option>
                  <option value="negado">Negado</option>
                  <option value="concluido">Concluido</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Valor Aprovado (R$)</label>
                <input type="number" step="0.01" min="0" value={form.approved_value} onChange={function(e) { handleChange("approved_value", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="claim-approved" />
              </div>
            </div>
          )}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Observacoes</label>
            <textarea value={form.notes} onChange={function(e) { handleChange("notes", e.target.value); }} rows={2} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="claim-notes" />
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onCancel} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">Cancelar</button>
            <button type="submit" disabled={saving} className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg text-sm font-medium hover:bg-blue-600 disabled:opacity-50" data-testid="save-claim-btn">
              {saving ? "Salvando..." : (isEdit ? "Salvar" : "Registrar Sinistro")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
